var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "Topic-title" }, [_vm._v("已订阅 Topic 列表")]),
    _c(
      "div",
      { staticClass: "mt10" },
      [
        _c(
          "vxe-table",
          {
            attrs: {
              border: "",
              "row-id": "id",
              data: _vm.TopicList,
              align: "left",
            },
          },
          [
            _c("vxe-table-column", {
              attrs: {
                type: "seq",
                "show-overflow": "",
                width: "50",
                title: "序号",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "Topic",
                "show-overflow": "",
                "min-width": "520",
                title: "设备的 Topic",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }